import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Separate axios instance for the kiosk — kiosk JWT is held in memory + localStorage
// (separate key from admin), and never co-mingled with the admin axios instance.
const kioskApi = axios.create({
  baseURL: API,
  timeout: 30000,
});

let _kioskToken = null;

export function setKioskToken(token) {
  _kioskToken = token;
  if (token) {
    kioskApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("eb_kiosk_token", token);
  } else {
    delete kioskApi.defaults.headers.common["Authorization"];
    localStorage.removeItem("eb_kiosk_token");
  }
}

export function getKioskToken() {
  if (_kioskToken) return _kioskToken;
  const stored = localStorage.getItem("eb_kiosk_token");
  if (stored) {
    _kioskToken = stored;
    kioskApi.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
  }
  return _kioskToken;
}

export function clearKioskToken() {
  setKioskToken(null);
}

// init from localStorage
getKioskToken();

export default kioskApi;
